import dayjs from 'dayjs';

export type DeleteRequestType = 'bump-up' | 'material-mapping';

export const MESSAGES = {
  API_ERROR: 'Oops! Error with one of the API calls.',
  RETRY_BUTTON: 'Retry',
  APP_LOADING: 'Please Wait, Loading Cockpit Application...',
  // Add more messages as needed
};

export const confirmMessage = (isSync: boolean = false, requestType: string = 'bump-up') => {
  let cutOffDate: any = '';
  let cutOffDateMessage: string = '';
  const requestLabel = requestType === 'material-mapping' ? 'for the old material' : 'without the bump-up effect';

  if (isSync) {
    const inputDate = dayjs.utc();
    // Define cutoff time (12:30 AM UTC on same day)
    let cutoffTime = inputDate.utc().startOf('day').add(23, 'hour').add(30, 'minute');
    const inputHour = inputDate.utc().hour();
    if (inputHour >= 0 && inputHour < 5) {
      cutoffTime = cutoffTime.subtract(1, 'day');
    }

    // Compare and decide
    if (inputDate.isBefore(cutoffTime)) {
      // Before 11:30PM UTC → next day
      cutOffDate = inputDate.add(1, 'day');
    } else {
      // After or equal to 11:30PM  AM UTC → day after next
      cutOffDate = inputDate.add(2, 'day');
    }
    cutOffDate = cutOffDate.local().format('MMMM Do, YYYY');
    cutOffDateMessage = `OrderSmart orders generated from<b> ${cutOffDate}</b> will be sent ${requestLabel}`;
    if (requestType === 'innovation-prediction') {
      cutOffDateMessage = `OrderSmart will no longer predict Innovation material from<b> ${cutOffDate}</b>`;
    }
  }

  return {
    message: isSync
      ? `Would you like to end this active request?<br> ${cutOffDateMessage} `
      : `Would you like to delete this ${requestType} request?`,
    confimBtnLable: 'Yes',
    cancelBtnLabel: 'Cancel',
    title: isSync ? 'End Active Request' : 'Delete Request?',
  };
};

export const confirmMessageManageHierachy = {
  message: 'Are you sure you want to remove this user from the Hierarchy?',
  confimBtnLable: 'Yes',
  cancelBtnLabel: 'Cancel',
  title: 'Delete Confirmation',
};

export const bumpUpTooltipMessageMapping = {
  deleteTooltip: 'Delete Bump up Request',
  deletingTooltip: 'Deleting Bump up Request',
  editTooltip: 'Edit this request',
  editSyncTooltip: 'Cannot Edit Active Request',
};

export const manageHierarchyTooltipMessageMapping = {
  deleteTooltip: 'Remove Sales Representative',
  deletingTooltip: 'Removing Sales Representative...',
};

export const matrialMappingTooltipMessages = {
  deleteTooltip: 'Delete Request',
  deletingTooltip: 'Deleting Request',
  editTooltip: 'Edit this request',
  editSyncTooltip: 'Cannot Edit Active Request',
};
export const temporaryMaterialTooltipMessages = {
  deleteTooltip: 'Delete Request',
  deletingTooltip: 'Deleting Request',
  editTooltip: 'Edit this request',
  editSyncTooltip: 'Cannot Edit Active Request',
};
export const permanentMaterialTooltipMessages = {
  deleteTooltip: 'Delete Request',
  deletingTooltip: 'Deleting Request',
  editTooltip: 'Edit this request',
  editSyncTooltip: 'Cannot Edit Active Request',
};
